
import Vue from "vue";
import {ResultError} from "@/api-client";
import {Prop} from "vue-property-decorator";
import Component from "vue-class-component";

@Component({})
export default class ErrorsSummary extends Vue {

    @Prop({ required: true })
    resultError!: ResultError;
    
}
